import './ToggleSectionButton.css'

import classNames from 'classnames'
import React from 'react'
import { noop } from 'utils'

import Box from '@mui/material/Box'

interface Props {
  isCollapsed?: boolean
  onClick?: () => void
}

function ToggleSectionButton({ isCollapsed = false, onClick = noop }: Props) {
  const className = classNames('toggle-section-button cursor-pointer', {
    'icon-plus': isCollapsed,
    'icon-minus': !isCollapsed,
  })

  return <Box className={className} onClick={onClick} />
}

export default ToggleSectionButton
